export default __webpack_public_path__ + "static/media/modesty.bbf4af9e.jpg";